import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px;
  background: #fff;
  border-bottom: 1px solid #e5e6eb;
  border-radius: 8px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .title {
    flex: 1;
    color: #1d2129;
    font-family: Poppins;
    font-size: 20px;
    font-weight: 600;
  }
`;

export const AddStaffButton = styled.button`
  display: flex;
  height: 48px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 12px;
  border: 1px solid #d2464f;
  border-radius: 4px;
  background: #fff6f9;
  color: #d2464f;
  font-family: Poppins;
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
  cursor: pointer;
`;

export const StaffBlockBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background: #f6f7fc;
  border-radius: 8px;
`;

export const StaffRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  .staff-info {
    display: flex;
    flex: 1;
    align-items: center;
    gap: 4px;
    min-width: 0;
  }
  .avatar {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }
  .name {
    color: #1d2129;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    white-space: nowrap;
  }
  .action {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .time {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 8px;
    color: #2563eb;
    font-family: Poppins;
    font-size: 18px;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
  }
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 5px;
  background: transparent;
  cursor: pointer;
  color: #1d2129;
  font-size: 20px;
  &.small {
    width: 32px;
    height: 32px;
  }
  &.delete {
    color: #da072d;
  }
`;

export const RequestButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #ccd4dc;
  background: #fff;
  .check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 100px;
    background: #e5e6eb;
    color: #fff;
  }
  &[data-active='true'] {
    border-color: #d2464f;
    background: #d2464f;
    .check {
      background: #fff;
      color: #d2464f;
    }
  }
`;

export const ServiceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const ServiceRowBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  overflow: hidden;
  .info {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
  }
  .service-name {
    color: #1d2129;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .time {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #2563eb;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    white-space: nowrap;
    cursor: pointer;
  }
  .duration {
    color: #64748b;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    white-space: nowrap;
  }
`;

export const AddServiceButton = styled.button`
  display: flex;
  height: 48px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 24px;
  width: 100%;
  border: 1px dashed #2d6772;
  border-radius: 4px;
  background: #fff;
  color: #2d6772;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
`;
